import Vue from 'vue'
import Router from 'vue-router'
import i18n from './assets/i18n/i18n'
import { store } from './store/store'

import Login from './pages/Login'
import Dashboard from './pages/1_dashboard/Dashboard'

// PUBLISHING
// Works
import WorksList from './pages/2_publishing/1_works/WorksList'
import WorksEdit from './pages/2_publishing/1_works/_edit/WorksEdit'
// Sheets
import Sheets from './pages/2_publishing/2_sheets/SheetsList'
import SheetsEdit from './pages/2_publishing/2_sheets/_edit/SheetsEdit'
// Releases
import PublishingProjects from './pages/2_publishing/3_projects/PublishingProjectsList'
import PublishingProjectsEdit from './pages/2_publishing/3_projects/_edit/PublishingProjectsEdit'
// Income
import IncomeList from './pages/2_publishing/4_income/IncomeList'
// Statements
import PublishingStatementsList from './pages/2_publishing/5_statements/PublishingStatementsList'
// Tracking
import Tracking from './pages/2_publishing/7_tracking/Tracking'
// Statistics
import PublishingStatistics from './pages/2_publishing/6_statistics/PublishingStatistics'
// Usage
import UsageList from './pages/2_publishing/8_usage/UsageList'
import UsageReview from './pages/2_publishing/8_usage/review/UsageReview'

// LABEL
// Tracks
import TracksList from './pages/3_label/1_tracks/TracksList'
import TracksEdit from './pages/3_label/1_tracks/_edit/TracksEdit'
// Releases
import ReleasesList from './pages/3_label/2_releases/ReleasesList'
import LabelReleasesEdit from './pages/3_label/2_releases/_edit/ReleasesEdit'
// Projects
import LabelProjectsList from './pages/3_label/3_projects/LabelProjectsList'
import LabelProjectsEdit from './pages/3_label/3_projects/_edit/LabelProjectsEdit'
// Sales Data
import SalesDataList from './pages/3_label/4_salesdata/SalesDataList'
// Statements
import LabelStatementsList from './pages/3_label/5_statements/LabelStatementsList'
// Statistics
// import LabelStatisticsList from './pages/3_label/6_statistics/LabelStatisticsList'
import LabelStatistics from './pages/3_label/6_statistics/LabelStatistics'

// ERP
// Pricelists
import PricelistsList from './pages/4_erp/1_pricelists/PricelistsList'
import PricelistsEdit from './pages/4_erp/1_pricelists/_edit/PricelistsEdit'
// Inventories
import InventoriesList from './pages/4_erp/2_inventories/InventoriesList'
// Shipping documents
import ShippingList from './pages/4_erp/3_shipping/ShippingList'
import ShippingEdit from './pages/4_erp/3_shipping/_edit/ShippingEdit'
// Invoices
import InvoicesList from './pages/4_erp/4_invoices/InvoicesList'
import InvoicesEdit from './pages/4_erp/4_invoices/_edit/InvoicesEdit'

// A-Z
// Groups
import AzGroupsList from './pages/5_az/1_groups/AzGroupsList'
import AzGroupsEdit from './pages/5_az/1_groups/_edit/AzGroupsEdit'
// Persons
import AzPersonsList from './pages/5_az/2_persons/AzPersonsList'
import AzPersonsEdit from './pages/5_az/2_persons/_edit/AzPersonsEdit'
// Distributors
import AzDistributorsList from './pages/5_az/3_distributors/AzDistributorsList'
import AzDistributorsEdit from './pages/5_az/3_distributors/_edit/AzDistributorsEdit'
// Societies
import AzSocietiesList from './pages/5_az/4_societies/AzSocietiesList'
import AzSocietiesEdit from './pages/5_az/4_societies/_edit/AzSocietiesEdit'
// Live
import AzLiveList from './pages/5_az/5_live/AzLiveList'
import AzLiveEdit from './pages/5_az/5_live/_edit/AzLiveEdit'

// CONTRACTS
// Publishing
import PublishingContractsList from './pages/6_contracts/1_publishing/PublishingContractsList'
import PublishingContractsEdit from './pages/6_contracts/1_publishing/_edit/PublishingContractsEdit'
// Label
import LabelContractsList from './pages/6_contracts/2_label/LabelContractsList'
import LabelContractsEdit from './pages/6_contracts/2_label/_edit/LabelContractsEdit'

// SERVICE CENTER
// Insights
import InsightsList from './pages/8_servicecenter/1_insights/InsightsList'

// ACCOUNT
// Credentials
import CredentialsList from './pages/7_account/5_credentials/CredentialsList'
// Companies
import CompaniesEdit from './pages/7_account/2_companies/_edit/CompaniesEdit'
// Settings
import Settings from './pages/7_account/4_settings/Settings'
// Modules
import Modules from './pages/7_account/3_modules/Modules'
// Mappings
import MappingsList from './pages/7_account/6_mappings/MappingsList'
import MappingsEdit from './pages/7_account/6_mappings/_edit/MappingsEdit'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },    
    {
      path: '*',
      name: '404',
      redirect: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true, parentName: 'lang_DASHBOARD', childName:  ''}
    },
  // PUBLISHING
    // Works
    {
      path: '/publishing/works',
      name: 'Works',
      component: WorksList,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_CAPTION_WORKS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedWorks', [])
        next()
      }
    },
    {
      path: '/publishing/works/:alvId',
      name: 'WorksEdit',
      component: WorksEdit,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_CAPTION_WORKS' }
    }, 
    // Sheets
    {
      path: '/publishing/sheets',
      name: 'Sheets',
      component: Sheets,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_SHEETS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedSheets', [])
        next()
      }
    }, 
    {
      path: '/publishing/sheets/:alvId',
      name: 'SheetsEdit',
      component: SheetsEdit,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_SHEETS', disabledBreadcrumbs: true }
    },
    // Releases
    {
      path: '/publishing/projects',
      name: 'PublishingProjects',
      component: PublishingProjects,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_PROJECTS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedPublishingProjects', [])
        next()
      }
    },    
    {
      path: '/publishing/projects/:alvId',
      name: 'PublishingProjectsEdit',
      component: PublishingProjectsEdit,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_PROJECTS', disabledBreadcrumbs: true }
    },
    // Income
    {
      path: '/publishing/income',
      name: 'Income',
      component: IncomeList,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_INCOME'}
    },
    // Statements
    {
      path: '/publishing/statements',
      name: 'PublishingStatements',
      component: PublishingStatementsList,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_STATEMENTS' }
    },
    // Tracking
    {
      path: '/publishing/tracking',
      name: 'Tracking',
      component: Tracking,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_TRACKING' }
    },
    // Statistics
    {
      path: '/publishing/statistics',
      name: 'PublishingStatistics',
      component: PublishingStatistics,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_STATISTICS' }
    },
    // Usage
    {
      path: '/publishing/usage',
      name: 'Usage',
      component: UsageList,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_USAGE' }
    },
    {
      path: '/publishing/usage/:alvId/review',
      name: 'UsageReview',
      component: UsageReview,
      meta: { requiresAuth: true, parentName: 'lang_PUBLISHING', childName:  'lang_PUBLISHING_USAGE', disabledBreadcrumbs: true }
    },

  // LABEL
    // Tracks
    {
      path: '/label/tracks',
      name: 'Tracks',
      component: TracksList,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_TRACKS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedTracks', [])
        next()
      }
    }, 
    {
      path: '/label/tracks/:alvId',
      name: 'TracksEdit',
      component: TracksEdit,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_TRACKS', disabledBreadcrumbs: true }
    },
    // Releases
    {
      path: '/label/releases',
      name: 'LabelReleases',
      component: ReleasesList,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_RELEASES' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedLabelReleases', [])
        next()
      }
    },
    {
      path: '/label/releases/:alvId',
      name: 'LabelReleasesEdit',
      component: LabelReleasesEdit,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_RELEASES', disabledBreadcrumbs: true }
    },
    // Projects
    {
      path: '/label/projects',
      name: 'LabelProjectsList',
      component: LabelProjectsList,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_PROJECTS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedLabelProjects', [])
        next()
      }
    },
    {
      path: '/label/projects/:alvId',
      name: 'LabelProjectsEdit',
      component: LabelProjectsEdit,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_PROJECTS', disabledBreadcrumbs: true }
    },
    // Sales Data
    {
      path: '/label/salesdata',
      name: 'SalesData',
      component: SalesDataList,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_SALES_DATA' }
    },
    // Statements
    {
      path: '/label/statements',
      name: 'LabelStatements',
      component: LabelStatementsList,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_STATEMENTS' }
    },
    // Statistics
    // {
    //   path: '/label/statistics',
    //   name: 'LabelStatisticsList',
    //   component: LabelStatisticsList,
    //   meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_STATISTICS' }
    // },
    {
      path: '/label/statistics',
      name: 'LabelStatistics',
      component: LabelStatistics,
      meta: { requiresAuth: true, parentName: 'lang_LABEL', childName:  'lang_LABEL_STATISTICS' }
    },

  // ERP 
    {
      path: '/erp/pricelists',
      name: 'Pricelists',
      component: PricelistsList,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_PRICELISTS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedPricelists', [])
        next()
      }
    }, 
    {
      path: '/erp/pricelists/:alvId',
      name: 'PricelistsEdit',
      component: PricelistsEdit,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_PRICELISTS', disabledBreadcrumbs: true }
    }, 
    {
      path: '/erp/inventories',
      name: 'Inventories',
      component: InventoriesList,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_INVENTORIES' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedInventories', [])
        next()
      }
    },  
    {
      path: '/erp/shipping',
      name: 'Shipping',
      component: ShippingList,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_SHIPPING' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedShipping', [])
        next()
      }
    }, 
    {
      path: '/erp/shipping/:alvId',
      name: 'ShippingEdit',
      component: ShippingEdit,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_SHIPPING', disabledBreadcrumbs: true },
      //To hide shipping inventories tooltip
      beforeEnter:(to,from, next)=>{
        store.commit('setShowShippingInventoriesPreview', false)
        store.commit('setInvokeSaveCallForShippingInventories', false)
        next()
      }
    },  
    {
      path: '/erp/invoices',
      name: 'Invoices',
      component: InvoicesList,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_INVOICES' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedInvoices', [])
        next()
      }
    },
    {
      path: '/erp/invoices/:alvId',
      name: 'InvoicesEdit',
      component: InvoicesEdit,
      meta: { requiresAuth: true, parentName: 'lang_ERP', childName:  'lang_ERP_INVOICES', disabledBreadcrumbs: true }
    },
  
  // A-Z
    // Persons
    {
      path: '/az/azpersons',
      name: 'AzPersons',
      component: AzPersonsList,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_PERSONS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedAzPersons', [])
        next()
      }
    },     
    {
      path: '/az/azpersons/:alvId',
      name: 'AzPersonsEdit',
      component: AzPersonsEdit,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_PERSONS', disabledBreadcrumbs: true }
    },
    // Distributors
    {
      path: '/az/azdistributors',
      name: 'AzDistributorsList',
      component: AzDistributorsList,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_DISTRIBUTORS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedInvoices', [])
        next()
      }
    },
    {
      path: '/az/azdistributors/:alvId',
      name: 'AzDistributorsEdit',
      component: AzDistributorsEdit,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_DISTRIBUTORS', disabledBreadcrumbs: true }
    },
    // Groups
    {
      path: '/az/azgroups',
      name: 'AzGroupsList',
      component: AzGroupsList,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_GROUPS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedAzGroups', [])
        next()
      }
    },
    {
      path: '/az/azgroups/:alvId',
      name: 'AzGroupsEdit',
      component: AzGroupsEdit,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_GROUPS', disabledBreadcrumbs: true }
    },
    // Societies
    {
      path: '/az/azsocieties',
      name: 'AzSocietiesList',
      component: AzSocietiesList,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_SOCIETIES' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedAzSocieties', [])
        next()
      }
    },
    {
      path: '/az/azsocieties/:alvId',
      name: 'AzSocietiesEdit',
      component: AzSocietiesEdit,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_SOCIETIES', disabledBreadcrumbs: true }
    },
    // Live
    
    {
      path: '/az/azlive',
      name: 'AzLiveList',
      component: AzLiveList,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_LIVE' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedAzLive', [])
        next()
      }
    },
    {
      path: '/az/azlive/:alvId',
      name: 'AzLiveEdit',
      component: AzLiveEdit,
      meta: { requiresAuth: true, parentName: 'lang_GENERIC_CAPTION_AZ', childName:  'lang_AZ_LIVE', disabledBreadcrumbs: true }
    },
    
  // CONTRACTS
    // Publishing
    {
      path: '/contracts/publishing',
      name: 'PublishingContracts',
      component: PublishingContractsList,
      meta: { requiresAuth: true, parentName: 'lang_CONTRACTS', childName:  'lang_CONTRACTS_PUBLISHING_CONTRACTS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedPublishingContracts', [])
        next()
      }
    },   
    {
      path: '/contracts/publishing/:alvId',
      name: 'PublishingContractsEdit',
      component: PublishingContractsEdit,
      meta: { requiresAuth: true, parentName: 'lang_CONTRACTS', childName:  'lang_CONTRACTS_PUBLISHING_CONTRACTS', disabledBreadcrumbs: true }
    },
    // Label
    {
      path: '/contracts/label',
      name: 'LabelContracts',
      component: LabelContractsList,
      meta: { requiresAuth: true, parentName: 'lang_CONTRACTS', childName:  'lang_CONTRACTS_LABEL_CONTRACTS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedLabelContracts', [])
        next()
      }
    },   
    {
      path: '/contracts/label/:alvId',
      name: 'LabelContractsEdit',
      component: LabelContractsEdit,
      meta: { requiresAuth: true, parentName: 'lang_CONTRACTS', childName:  'lang_CONTRACTS_LABEL_CONTRACTS', disabledBreadcrumbs: true }
    },
    
  // ACCOUNT
    // Mappings
    {
      path: '/account/mappings',
      name: 'Mappings',
      component: MappingsList,
      meta: { requiresAuth: true, parentName: 'lang_ACCOUNT', childName:  'lang_ACCOUNT_MAPPINGS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedMappings', [])
        next()
      }
    },
    {
      path: '/account/mappings/:alvId',
      name: 'MappingsEdit',
      component: MappingsEdit,
      meta: { requiresAuth: true, parentName: 'lang_ACCOUNT', childName:  'lang_ACCOUNT_MAPPINGS', disabledBreadcrumbs: true }
    },
    // Credentials
    {
      path: '/account/credentials',
      name: 'Credentials',
      component: CredentialsList,
      meta: { requiresAuth: true, parentName: 'lang_ACCOUNT', childName:  'lang_ACCOUNT_CREDENTIALS' }
    },
    // Companies
    {
      path: '/account/companies',
      name: 'CompaniesEdit',
      component: CompaniesEdit,
      meta: { requiresAuth: true, parentName: 'lang_ACCOUNT', childName:  'lang_ACCOUNT_COMPANIES', disabledBreadcrumbs: true }
    },
    // Settings
    {
      path: '/account/settings',
      name: 'Settings',
      component: Settings,
      meta: { requiresAuth: true, parentName: 'lang_ACCOUNT', childName:  'lang_ACCOUNT_SETTINGS' }
    }, 
    // Modules
    {
      path: '/account/modules',
      name: 'Modules',
      component: Modules,
      meta: { requiresAuth: true, parentName: 'lang_ACCOUNT', childName:  'lang_ACCOUNT_MODULES' }
    },

  // SERVICE CENTER
    // Insights
    {
      path: '/servicecenter/insights',
      name: 'Insights',
      component: InsightsList,
      meta: { requiresAuth: true, parentName: 'lang_NAVIGATION_SERVICE_CENTER', childName: 'lang_SERVICE_CENTER_CAPTION_INSIGHTS' },
      beforeEnter: (to, from, next) => {
        store.commit('setExpandedInsights', [])
        next()
      }
    },
  ]
})

router.beforeEach(async (to, from, next) => {  
  // await store.dispatch('fetchI18nMessages')
  
  // setting paging informations to default
  // Preserve pagination when navigating back from edit page to its list page
  const isReturningToList = from.params.alvId && !to.params.alvId && to.path === from.path.replace(/\/[^/]+$/, '')
  const isGoingToEdit = !from.params.alvId && to.params.alvId && from.path === to.path.replace(/\/[^/]+$/, '') 
  if (!isReturningToList && !isGoingToEdit) {
    store.commit('setCurrentPage', 1)
    store.commit('setTotalRecords', 0)
    store.commit('setTotalListed', 0)
    store.commit('setNumberOfPages', 0)
  }

  await store.dispatch('fetchI18nMessages', localStorage.getItem('uiLanguage') || i18n.locale)
  store.dispatch("changeIsLoggedIn")

  if(store.getters.getIsLoggedIn && Object.keys(store.getters.getUser).length === 0) { 
    store.commit('setUser', JSON.parse(localStorage.getItem('userData')).user)  
  }
  if (store.getters.getIsLoggedIn) {
    // Retrieve the user's details from the store
    const userId = store.getters.getUser.id;
        
    // Call Mixpanel identify
    mixpanel.identify(userId);
     
    // Set user properties in Mixpanel
    mixpanel.people.set({
      '$last_login': new Date(),
      // ... any other properties we want to track
    });
    
    // Initialize Ably for real-time task notifications (only once)
    if (!store.getters.getAbly) {
      // Load persisted task notifications from LocalStorage
      store.commit('loadTaskNotificationsFromStorage')
      
      store.dispatch('fetchAblyRequestToken').then(connected => {
        if (connected) {
          store.dispatch('subscribeToTaskNotifications')
        }
      })
    }
  }

  if (to.meta.requiresAuth && !store.getters.getIsLoggedIn) next('/login')
  else next()

  store.commit('setDrawer', store.getters.getOpenDriver)
})